import { Cell, flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { ReactNode } from 'react';

import styles from '../Table.module.scss';

import { ColumnMetaDef } from './TableFilter';

type TableColProps<T> = {
  href?: string | null;
  onClick?: (
    event: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    cell: Cell<T, unknown>,
  ) => void;
  cell: Cell<T, unknown>;
};

function TableCol<T>({ href, cell, onClick }: TableColProps<T>) {
  const colWrapper = (content: ReactNode) => {
    if (href) {
      return (
        <Link href={href} className={styles.link}>
          {content}
        </Link>
      );
    }
    return <>{content}</>;
  };

  const clickHandler = (event: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
    onClick?.(event, cell);
  };

  const meta = cell.column.columnDef.meta as ColumnMetaDef;
  const { contentAlignment } = meta || {};

  return (
    <td
      data-testid={`column-${cell.column.id}-row-${cell.row.index}`}
      className={classNames([styles.col, contentAlignment && styles[contentAlignment]], styles.col)}
      onClick={clickHandler}>
      {colWrapper(flexRender(cell.column.columnDef.cell, cell.getContext()))}
    </td>
  );
}

export { TableCol };
